/**
 * JornadaPicker.jsx · v101.8.0 · Jornada (turno) del técnico — SOLO LECTURA.
 * Fuente única de horarios: «Horarios de Técnicos» (/admin/horarios). Aquí solo se muestra,
 * junto con el chequeo de configuración completa para el autoagendamiento (zona, bodega, jornada).
 */
import { useEffect, useState } from "react";
import api from "../lib/api";

export default function JornadaPicker({ userId, zoneIds = [], warehouseId, testIdPrefix = "jornada" }) {
  const [names, setNames] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    setLoaded(false);
    if (!userId) { setNames([]); setLoaded(true); return; }
    api.get(`/v1/shifts/technician/${userId}`)
      .then((r) => setNames(r.data?.names || []))
      .catch(() => setNames([]))
      .finally(() => setLoaded(true));
  }, [userId]);

  const ok = (b) => (b ? "✓" : "✗");
  const hasZone = (zoneIds || []).length > 0;
  const hasWh = !!warehouseId;
  const hasJ = names.length > 0;

  return (
    <div className="space-y-1.5" data-testid={`${testIdPrefix}-info`}>
      <div className="text-sm px-3 py-2 rounded-lg border border-gray-200 bg-gray-50 text-gray-700">
        {!loaded ? "Cargando…" : hasJ ? names.join(" · ") : "Sin jornada (no recibe OTs automáticas)"}
      </div>
      <div className="text-[11px] text-gray-500">
        La jornada se asigna en <a href="/admin/horarios" className="underline">Horarios de Técnicos</a>.
      </div>
      <div className="text-[11px]" style={{ color: hasZone && hasWh && hasJ ? "#047857" : "#B45309" }}
           data-testid={`${testIdPrefix}-config`}>
        Configuración para autoagendamiento: {ok(hasZone)} zona · {ok(hasWh)} bodega · {ok(hasJ)} jornada
        {hasZone && hasWh && hasJ ? " — completa" : " — incompleta: no recibirá OTs automáticas"}
      </div>
    </div>
  );
}
